import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastForward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFastForward"><Path d="M14.4295 5.38602C13.4458 4.60944 12 5.31009 12 6.56335V9.78381L6.42947 5.38602C5.4458 4.60945 4 5.31008 4 6.56335V17.4362C4 18.6895 5.4458 19.3901 6.42947 18.6136L12 14.2158V17.4362C12 18.6895 13.4458 19.3901 14.4295 18.6136L21.3156 13.1771C22.0764 12.5766 22.0763 11.423 21.3156 10.8225L14.4295 5.38602Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFastForward;
